import { consoleHandler, datadogHandler } from './handlers';
import { errorCategoryMiddleware, uuidScrubberMiddleware } from './middleware';

export const DEFAULT_HANDLERS = [datadogHandler, consoleHandler];
export const DEFAULT_MIDDLEWARES = [uuidScrubberMiddleware, errorCategoryMiddleware];
